import React, { useContext, useState } from 'react'
import './index.sass'
import moment from 'moment';
import { DarkModeContext } from '../../global/Theme'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import FeedCardActions from './FeedCardActions';
import { makeComment } from '../../api/feed';
import { useRef } from 'react';
import Notifer from './Notifiers'
import TipModal from './TipModal'
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";


import {
    v4 as uuidv4
} from 'uuid';
import { useEffect } from 'react';
import { getUserByID } from '../../api/auth';

const FeedCardLazy = (function FeedCard({ postId, body, image, likesCount, commentsCount, time, location, type, likeMap, bookmarkMap, commentMap, placeholder, userID }) {
    const { isDark } = useContext(DarkModeContext);

    const history = useHistory()
    const dispatch = useDispatch();

    const userData = useSelector(state => state.userState)
    const [comment, setComment] = useState("");
    const [commentBtnState, setCommentBtn] = useState("POST");
    const [notifiers, setNotifiers] = useState([])
    const [deletedNotifiers, setDeletedNotifiers] = useState([])
    const [isTipModalVisible, setIsTipModalVisible] = useState(false);
    const commentInputRef = useRef();

    const [authorData, setAuthorData] = useState({username: '', thumbnail: '', image: ''})


    useEffect(()=>{
        loadAuthor()
    }, [likesCount])

    const gotoPost = () => {
        history.push({
            pathname: (type == 1) ? `/post/${postId}/img` : `/post/${postId}/mp4`
        })
    }

    const getTimeAgo = (time) => {
        try {
            return moment(new Date((time.seconds + time.nanoseconds * 10 ** -9) * 1000)).fromNow()
        } catch (e) { }
    }


    const loadAuthor = async () => {
         const res = await getUserByID(userID);
        setAuthorData(res);
    }

    const showNavbar = () => {
        dispatch({ type: "SHOW_NAVBAR" });

    }

    const hideNavbar = () => {
        dispatch({ type: "HIDE_NAVBAR" });
    }


    const handleCommentInputChange = (e) => {
        setComment(e.target.value);
    }

    const handleMakeComment = async () => {
        setCommentBtn('Wait..')
        if (comment.length > 0) {
            await makeComment(postId, comment, null, {});
            //await makeComment(postID, finalComment, commentParentID, mentionedUsers);

            setComment("")
            commentInputRef.current.value = "";
        }
        setCommentBtn("POST");
        handleOnComment()
    }

    const handleKeyPress = async (event) => {
        setCommentBtn('Wait..')

        if (event.key === 'Enter') {
            if (comment.length > 0) {
                await makeComment(postId, event.target.value, null, {});
                setComment("")
                commentInputRef.current.value = "";
                handleOnComment()

            }
        }
        setCommentBtn("POST");
    }


    const handleOpenProfile = () => {
        history.push(`/user/${authorData.username}`)
    }

    // notifier handlers
    const sleep = async (ms) => {
        return new Promise(resolve => setTimeout(resolve, ms))
    }

    const handleCloseNotifier = (id) => {
        setDeletedNotifiers(deletedNotifiers => [...deletedNotifiers, id])

    }

    const handleCloseTipModal = async () => {
        if (!isTipModalVisible) {
            setIsTipModalVisible(!isTipModalVisible)
            return;
        }
        document.getElementById(`${postId}_tip`).style.transform = 'scale(0)'
      //  await sleep(1500)
        setIsTipModalVisible(!isTipModalVisible)
    }

    useEffect(() => {
        const n = notifiers.filter(notifier => !deletedNotifiers.includes(notifier.id))
        // console.log("new Notifiers list", notifiers)
        setNotifiers(n)
    }, [deletedNotifiers])

    const handleOnBookmark = async () => {
        const uid = uuidv4().toString().replaceAll('-', '')
        setNotifiers(notifiers => [...notifiers, { content: 'Added to Bookmarks!', icon: 'notifierbook.svg', id: uid }])
        try {
            await sleep(500)
            document.getElementById(uid).style.opacity = 1
        } catch (e) { }
        await sleep(2500)
        try {
            document.getElementById(uid).style.opacity = 0
            await sleep(500)
        } catch (e) { }
        setDeletedNotifiers(deletedNotifiers => [...deletedNotifiers, uid])
    }

    const handleOnComment = async () => {
        const uid = uuidv4().toString().replaceAll('-', '')
        // console.log("Adding to notifiers", uid)
        setNotifiers(notifiers => [...notifiers, { content: 'Comment Added!', icon: 'notifiercomment.svg', id: uid }])
        try {
            await sleep(500)
            document.getElementById(uid).style.opacity = 1
        } catch (e) { }
        await sleep(2500)
        try {
            document.getElementById(uid).style.opacity = 0
            await sleep(500)
        } catch (e) { }
        setDeletedNotifiers(deletedNotifiers => [...deletedNotifiers, uid])

    }

    return (
        <div className={`feed-card ${isDark ? 'feed-dark' : 'feed-light'}`} id={postId}>
            <div className="feed-header">
               {authorData.image != '' ? <LazyLoadImage 
                    placeholderSrc={authorData.thumbnail}
                    effect="opacity"
                    onClick={handleOpenProfile}
                    threshold={100}
                    height={30}
                    src={authorData.image}
                    width={30}
                     /> : <div style={{height: 50}}> </div>
    }
                <div>
                    <h5 onClick={handleOpenProfile}>{authorData.username}</h5>
                    <p>{location}</p>
                </div>
            </div>

            <div className="feed-img" >
                <div className="notifiers">
                    {isTipModalVisible && <TipModal id={`${postId}_tip`} onCloseClick={handleCloseTipModal} />}
                    {
                        notifiers.map(notifier =>
                            <Notifer onCloseClick={handleCloseNotifier} id={notifier.id} content={notifier.content} icon={notifier.icon} />)
                    }
                </div>
               
                {type == 1 &&
                    // <TransformWrapper>
                    //     <TransformComponent>
                            <LazyLoadImage alt={image.alt}
                                placeholderSrc={placeholder || null}
                                effect="opacity"
                                onClick={gotoPost}
                                threshold={100}
                                height={placeholder && placeholder.height || null}
                                src={image}
                                width={placeholder && placeholder.width || null}
                                 />
                    //     </TransformComponent>
                    // </TransformWrapper>
                }
                {type == 2 && <video src={image} autoplay loop muted preload controls />}

            </div>
            <div className="feed-body">

                <FeedCardActions onTipClick={handleCloseTipModal} onBookmark={handleOnBookmark} commentMap={commentMap || []} postId={postId} bookmarkMap={bookmarkMap} likeMap={likeMap} likesCount={likesCount} commentsCount={commentsCount} type={type} username={userData.username} />
                <div className="feed-content">
                    <h5>{body}</h5>
                    <p>{getTimeAgo(time)}</p>
                </div>

                <div className="feed-footer">
                    <div className="feed-comment-box">
                        <div className={"feed-comment-profile"}>
                            <LazyLoadImage alt={userData.username}
                                placeholderSrc={userData.thumbnail}
                                effect="opacity"
                                onClick={handleOpenProfile}
                                threshold={100}
                                height={userData.image.height}
                                src={userData.image}
                                width={userData.image.width} />
                        </div>
                        <input ref={commentInputRef} onKeyPress={handleKeyPress} onChange={handleCommentInputChange} placeholder="Write a comment..." onBlur={showNavbar} onFocus={hideNavbar} />
                        <button onClick={handleMakeComment} className={comment.length > 0 ? "feed-comment-button-active" : "feed-comment-button"}>
                            {commentBtnState}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
})

export default FeedCardLazy;

